import types from "@/data/types"

const tbdCheckbox = (type) => {
    switch (type) {
        case types.OSS_API:
        case types.OSS_WEB:
        case types.OSS_APP:
            return true
        case types.BALLPARK_WEB:
        case types.BALLPARK_APP:
            return true
        case types.SG:
            return true
        default:
            return false
    }
}

export default tbdCheckbox
